import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const BrandBannersPage = lazy(() => import("../../pages/BrandBannersPage"));

export function RannieTeodoroRoutes() {
  return (
    <Switch>
      <Route path="/rt/brand-banners" component={BrandBannersPage} />
    </Switch>
  );
}

export const slug = "rt";
